<template>
    <div style="height: 100%;width: 100%;">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
            <el-tab-pane label="未分配" name="first"></el-tab-pane>
            <el-tab-pane label="已经分配" name="second"></el-tab-pane>
            <el-tab-pane label="全部" name="three"></el-tab-pane>
        </el-tabs>

        <van-search v-model="param" placeholder="请输入搜索关键词" @search="onSearch" @cancel="onSearch" @clear="onSearch"/>

        <el-table height="calc(100% - 10rem)" :data="beautyStaffs" show-header style="width: 100%;" border v-loadmore="laodMore">
            <el-table-column prop="membername" align="center" label="姓名">
                <template slot-scope="scope">
                    <div>{{scope.row.membername}}</div>
                    <div>{{scope.row.cardnumber}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="accoundate" align="center" label="最近到店"></el-table-column>
            <el-table-column prop="staffname" align="center" label="负责人">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.staffid" placeholder="请选择" size="mini" @change="setCardManager(scope)" clearable>
                        <el-option v-for="item in staffs" :key="item.staffid" :label="item.staffname" :value="item.staffid"></el-option>
                    </el-select>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                param:"",
                activeName:"first",
                storeid:localStorage.getItem("storeid"),
                beautyStaffs:[],
                curpage:1,
                isFinite:false,
                staffs:[],
                type:1,
            }
        },
        created: function () {
            this.getAllCardInfoDdInfo();
            this.getStaffByDeptId();
        },
        methods: {
            onSearch(){
                this.curpage=1;
                this.beautyStaffs=[];
                this.getAllCardInfoDdInfo();
            },
            setCardManager(scope){
                let headstaff=new Object();
                headstaff.storeid=this.storeid;
                headstaff.cardid=scope.row.cardid;
                headstaff.staffid=scope.row.staffid;
                headstaff.createtor=localStorage.getItem("staffid");
                headstaff.createtorname=localStorage.getItem("staffname");
                this.$postw("hairmanager/saveHeaderStaff",headstaff).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleClick(name){
                if(this.activeName=="first"){
                    this.beautyStaffs=[];
                    this.curpage=1;
                    this.type=1;
                    this.isFinite=false;
                    this.getAllCardInfoDdInfo();
                }
                else if(this.activeName=="second"){
                    this.beautyStaffs=[];
                    this.curpage=1;
                    this.type=2;
                    this.isFinite=false;
                    this.getAllCardInfoDdInfo();
                }
                else{
                    this.beautyStaffs=[];
                    this.curpage=1;
                    this.type=0;
                    this.isFinite=false;
                    this.getAllCardInfoDdInfo();
                }
            },
            getStaffByDeptId(){
                this.$post("staff/getStaffByPosHair",{storeid:this.storeid,deptid:"31"}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                if(val.posid=="ca5f888b2acc46b98d6d2f265ae5101a" || val.posid=="f1f91003a7464557af536065a06df68e" || val.posid=="4aebd0e8576b459c9f3eec52f1e21d1e"
                                || val.posid=="42d7c57fc37e4b2c83b89babb6d33487" || val.posid=="9d6032cc834748f5bc2932ff73bd9d57" || val.posid=="9132ffd069fd494687c1c9bc929baf5d"){
                                    this.staffs.push(val);
                                }
                            }
                        }
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            laodMore(){
                console.log("12");
                if(this.isFinite==false){
                    this.curpage++;
                    this.getAllCardInfoDdInfo();
                }
                else{
                    this.$message({
                        message: '已经全部加载完成',
                        type: 'warning'
                    });
                }
            },
            getAllCardInfoDdInfo(){
                this.$post("hairmanager/getHairAllCardInfoDdInfo",{storeid:this.storeid,curpage:this.curpage,type:this.type,param:this.param}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj!=null && obj.length>0){
                            for(let val of obj){
                                this.beautyStaffs.push(val);
                            }
                        }
                        else{
                            this.isFinite=true;
                        }
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/page/manager/sendhaircard.vue